import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

export const AlertBell = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;
    const load = () =>
      api.get("/kris/alerts?state=active").then(({ data }) => active && setCount(data.count)).catch(() => {});
    load();
    const id = setInterval(load, 30000);
    window.addEventListener("kri:refresh", load);
    return () => {
      active = false;
      clearInterval(id);
      window.removeEventListener("kri:refresh", load);
    };
  }, []);

  return (
    <Link
      to="/alerts"
      data-testid="alert-bell"
      title="Early-warning alerts"
      className="relative flex h-9 w-9 items-center justify-center rounded-sm border border-white/15 text-white/60 transition-colors hover:border-ek-lilac hover:text-ek-lilac"
    >
      <Bell size={16} />
      {count > 0 && (
        <span
          data-testid="alert-bell-count"
          className="absolute -right-1.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white"
        >
          {count}
        </span>
      )}
    </Link>
  );
};
